/* eslint-disable max-len */
import { makeStyles } from '@mui/styles';
import Container from 'components/Container/Container';
import config from 'config';
import { memo } from 'react';
import { Helmet } from 'react-helmet-async';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'components/Img/features-hero.s... Remove this comment to see the full error message
import BgSvg from 'components/Img/features-hero.svg';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'components/Img/manin-peace.svg... Remove this comment to see the full error message
import ManInPace from 'components/Img/manin-peace.svg';
import WhyIcon from '@mui/icons-material/HelpOutline';
import HowToIcon from '@mui/icons-material/HowToRegOutlined';
import ShareIcon from '@mui/icons-material/Share';
import SecurityIcon from '@mui/icons-material/Security';

import { Typography, Paper, Grid } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const useStyles = makeStyles(
  (theme) => ({
    '@keyframes peaceicon': {
      '0%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
      '50%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,17)',
      },
      '100%': {
        animationTimingFunction: 'ease-in, ease-in-out',
        transform: 'matrix(1,0,0,1,3,8)',
      },
    },
    bg: {
      display: 'flex',
      color: '#fff',
      backgroundImage: `url(${BgSvg})`,
      fallbacks: [
        {
          backgroundImage: 'linear-gradient(-30deg, #00004d 0%, #5333ed 49%, #2cd4d9 100%)',
        },
      ],
      minHeight: 800,
      width: 'calc(100% + 2px)',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    },
    container100: {
      height: '100%',
    },
    containerFeatures: {
      paddingTop: 50,
      zIndex: 99,
      position: 'relative',
      top: -100,
      backgroundColor: '#e1eaf8',
      paddingBottom: 72,
      '&:after': {
        height: 72,
        width: '100%',
        position: 'absolute',
        zIndex: -1,
        bottom: 0,
        content: '" "',
        display: 'block',
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'><polygon fill='#fff' points='0,40 0,100 100,100 0,0' /></svg>\")",
        backgroundRepeat: 'no-repeat',
      },
    },
    paperFeatures: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(10),
    },
    typoWithIcon: {
      display: 'inline-flex',
    },
    iconsWithText: {
      fontSize: 28,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      marginRight: theme.spacing(3),
    },
    containerSecond: {
      position: 'relative',
      bottom: -120,
    },
    containerContentSecond: {
      textAlign: 'center',
    },
    peaceicon: {
      '& g > g > g > g:nth-child(2)': {
        animationName: '$peaceicon',
        animationDuration: '3s',
        animationIterationCount: 'infinite',
      },
    },
    paper: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
      height: 400,
    },
    paperNorrmal: {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'spacing' does not exist on type 'Default... Remove this comment to see the full error message
      padding: theme.spacing(5),
    },
    iconBox: {
      fontSize: 70,
      marginBottom: 40,
    },
    containerOver: {
      position: 'relative',
      top: -220,
    },
    manInPeace: {
      paddingTop: 40,
      paddingBottom: 50,
      backgroundImage: `url(${ManInPace})`,
      backgroundRepeat: 'no-repeat',
      // backgroundSize: 'contain',
      backgroundPosition: 'right top',
    },
  }),
  { name: 'BringerPrivacy' }
);

const Home = memo(
  () => {
    const classes = useStyles();
    const title = 'Bringer Parcel Xpress';
    // eslint-disable-next-line
    const description =
      'Ship anywhere in the world with a click. Our online tools let you ship with confidence without downloading software';

    const { t } = useTranslation();

    const ldjson = {
      '@context': 'http://schema.org',
      '@type': 'WebSite',
      url: config.domain,
      name: config.app.title,
      alternateName: 'Bringer',
      image: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    const ldjsonOrg = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: config.app.title,
      legalName: 'Bringer CORP',
      email: `mailto:contact@${config.host}`,
      url: config.domain,
      logo: `${config.domain}/bpx-logo-white.png`,
      sameAs: [
        'https://www.facebook.com/Bringer',
        'https://instagram.com/Bringer',
        'https://www.linkedin.com/company/Bringer/',
        'https://twitter.com/@Bringer',
      ],
    };

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <link rel="canonical" href={`${config.domain}/`} />
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="twitter:title" content={title} />
          <meta name="og:description" content={description} />
          <meta name="twitter:description" content={description} />
          <meta property="og:type" content="website" />
          <meta name="robots" content="index, follow" />
          <script type="application/ld+json">{JSON.stringify(ldjson)}</script>
          <script type="application/ld+json">{JSON.stringify(ldjsonOrg)}</script>
        </Helmet>
        <div className={classes.bg}>
          <Container>
            <Grid container alignItems="center" className={classes.container100}>
              <Grid item xs={12} sm={6}>
                <Typography variant="h2" component="h1" color="inherit" gutterBottom>
                  {t('public.privacy')}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </div>
        <div className={classes.containerFeatures}>
          <Container className={classes.containerOver}>
            <Grid container className={classes.containerSecond}>
              <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="space-between">
                  <Grid item xs={12} sm={12} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <WhyIcon className={classes.iconBox} />
                      <Typography variant="h6" gutterBottom align="left">
                        {t('public.privacy.why')}
                      </Typography>
                      <Typography variant="subtitle1" align="left">
                        {t('public.privacy.why.text')}
                      </Typography>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} sm={4} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <HowToIcon className={classes.iconBox} />
                      <Typography variant="h6" gutterBottom align="left">
                        {t('public.privacy.how')}
                      </Typography>
                      <Typography variant="subtitle1" align="left">
                        {t('public.privacy.how.text')}
                      </Typography>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} sm={4} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <ShareIcon className={classes.iconBox} />
                      <Typography variant="h6" gutterBottom align="left">
                        {t('public.privacy.share')}
                      </Typography>
                      <Typography variant="subtitle1" align="left">
                        {t('public.privacy.share.text')}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={4} className={classes.containerContentSecond}>
                    <Paper className={classes.paper} elevation={1}>
                      <SecurityIcon className={classes.iconBox} />
                      <Typography variant="h6" gutterBottom align="left">
                        {t('public.privacy.protect')}
                      </Typography>
                      <Typography variant="subtitle1" align="left">
                        {t('public.privacy.protect.text')}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
          <Grid container>
            <Grid item xs={12}>
              <div className={classes.manInPeace}>
                <Container>
                  <Grid container spacing={3}>
                    <Grid item={12} sm={5}>
                      <Typography variant="h4" gutterBottom>
                        {t('public.privacy.update')}
                      </Typography>
                      <Typography gutterBottom paragraph>
                        {t('public.privacy.update.text')}
                      </Typography>
                    </Grid>
                    <Grid xs={12} sm={7} />
                    <Grid item={12} sm={5}>
                      <Typography variant="h4" gutterBottom>
                        {t('public.privacy.contact.information')}
                      </Typography>
                      <Typography gutterBottom paragraph>
                        {t('public.privacy.contact.information.text')}
                        <br />
                        Bringer Parcel Xpress
                        <br />
                        (A division of Bringer Corporation)
                        <br />
                        8351 NW 21st Street,
                        <br />
                        Doral, FL, 33122
                        <br />
                        United States of America
                        <br />
                        Email: support@bringer.com
                        <br />
                      </Typography>
                    </Grid>
                  </Grid>
                </Container>
              </div>
            </Grid>
          </Grid>
          <Container>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <Paper className={classes.paperNorrmal}>
                  <Typography variant="h5" gutterBottom>
                    {t('public.privacy.overview')}
                  </Typography>
                  <Typography paragraph>{t('public.privacy.overview.p1')}</Typography>
                  <Typography paragraph>{t('public.privacy.overview.p2')}</Typography>
                  <Typography paragraph>{t('public.privacy.overview.p3')}</Typography>
                  <Typography paragraph>{t('public.privacy.overview.p4')}</Typography>
                  <Typography paragraph>
                    <strong>{t('public.privacy.overview.p5')}</strong>
                  </Typography>
                  <Typography paragraph>{t('public.privacy.overview.p6')}</Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
          <br />
        </div>
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.information')}
                </Typography>
                <Typography paragraph>{t('public.privacy.information.p1')}</Typography>
                <Typography paragraph>{t('public.privacy.information.p2')}</Typography>
                <Typography paragraph>
                  <ul>
                    <li>{t('public.privacy.information.p2.item.1')}</li>
                    <li>{t('public.privacy.information.p2.item.2')}</li>
                    <li>{t('public.privacy.information.p2.item.3')}</li>
                    <li>{t('public.privacy.information.p2.item.4')}</li>
                    <li>{t('public.privacy.information.p2.item.5')}</li>
                    <li>{t('public.privacy.information.p2.item.6')}</li>
                    <li>{t('public.privacy.information.p2.item.7')}</li>
                    <li>{t('public.privacy.information.p2.item.8')}</li>
                    <li>{t('public.privacy.information.p2.item.9')}</li>
                    <li>{t('public.privacy.information.p2.item.10')}</li>
                    <li>{t('public.privacy.information.p2.item.11')}</li>
                  </ul>
                </Typography>
                <Typography paragraph>{t('public.privacy.information.p3')}</Typography>
                <Typography paragraph>{t('public.privacy.information.p4')}</Typography>
                <Typography paragraph>{t('public.privacy.information.p5')}</Typography>
                <Typography paragraph>{t('public.privacy.information.p6')}</Typography>
                <Typography paragraph>{t('public.privacy.information.p7')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.information.obtain')}
                </Typography>
                <Typography paragraph>
                  <strong>{t('public.privacy.information.obtain.p1')}</strong>
                </Typography>
                <Typography paragraph>
                  <ul>
                    <li>{t('public.privacy.information.obtain.p1.item.1')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.2')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.3')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.4')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.5')}</li>
                    <li>
                      {t('public.privacy.information.obtain.p1.item.6.part.1')}{' '}
                      <a href="https://www.bringerparcel.com">
                        {t('public.privacy.information.obtain.p1.item.6.part.2')}
                      </a>{' '}
                      {t('public.privacy.information.obtain.p1.item.6.part.3')}
                    </li>
                    <li>{t('public.privacy.information.obtain.p1.item.7')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.8')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.9')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.10')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.11')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.12')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.13')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.14')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.15')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.16')}</li>
                    <li>{t('public.privacy.information.obtain.p1.item.17')}</li>
                  </ul>
                </Typography>
                <Typography paragraph>{t('public.privacy.information.obtain.p2')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.information.share')}
                </Typography>
                <Typography paragraph>{t('public.privacy.information.share.p1')}</Typography>
                <Typography paragraph>{t('public.privacy.information.share.p2')}</Typography>
                <Typography paragraph>{t('public.privacy.information.share.p3')}</Typography>
                <Typography paragraph>{t('public.privacy.information.share.p4')}</Typography>
                <Typography paragraph>{t('public.privacy.information.share.p5')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.access.correction')}
                </Typography>
                <Typography paragraph>
                  {t('public.privacy.access.correction.p1.part.1')}{' '}
                  <a href="https://www.bringerparcel.com">
                    {t('public.privacy.access.correction.p1.part.2')}
                  </a>{' '}
                  {t('public.privacy.access.correction.p1.part.3')}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.data.transfers')}
                </Typography>
                <Typography paragraph>{t('public.privacy.data.transfers.p1')}</Typography>
                <Typography paragraph>{t('public.privacy.data.transfers.p2')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.children')}
                </Typography>
                <Typography paragraph>{t('public.privacy.children.p1')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.protect.personal.information')}
                </Typography>
                <Typography paragraph>
                  {t('public.privacy.protect.personal.information.p1')}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.protect.personal.information.collect')}
                </Typography>
                <Typography paragraph>
                  <strong>{t('public.privacy.protect.personal.information.collect.p1')}</strong>
                </Typography>
                <Typography paragraph>
                  <ul>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.1')}</li>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.2')}</li>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.3')}</li>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.4')}</li>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.5')}</li>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.6')}</li>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.7')}</li>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.8')}</li>
                    <li>{t('public.privacy.protect.personal.information.collect.p1.item.9')}</li>
                  </ul>
                </Typography>
                <Typography paragraph>
                  {t('public.privacy.protect.personal.information.collect.p2')}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.disclosures')}
                </Typography>
                <Typography paragraph>{t('public.privacy.disclosures.p1')}</Typography>
                <Typography paragraph>{t('public.privacy.disclosures.p2')}</Typography>
                <Typography paragraph>{t('public.privacy.disclosures.p3')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.use.personal.information')}
                </Typography>
                <Typography paragraph>{t('public.privacy.use.personal.information.p1')}</Typography>
                <Typography paragraph>{t('public.privacy.use.personal.information.p2')}</Typography>
                <Typography paragraph>
                  <ul>
                    <li>{t('public.privacy.use.personal.information.p2.item.1')}</li>
                    <li>{t('public.privacy.use.personal.information.p2.item.2')}</li>
                    <li>{t('public.privacy.use.personal.information.p2.item.3')}</li>
                    <li>{t('public.privacy.use.personal.information.p2.item.4')}</li>
                    <li>{t('public.privacy.use.personal.information.p2.item.5')}</li>
                    <ul>
                      <li>{t('public.privacy.use.personal.information.p2.item.6')}</li>
                      <li>{t('public.privacy.use.personal.information.p2.item.7')}</li>
                    </ul>
                  </ul>
                </Typography>
                <Typography paragraph>{t('public.privacy.use.personal.information.p3')}</Typography>
                <Typography paragraph>{t('public.privacy.use.personal.information.p4')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.rights')}
                </Typography>
                <Typography paragraph>{t('public.privacy.rights.p1')}</Typography>
                <Typography>
                  <ul>
                    <li>
                      <strong>{t('public.privacy.rights.p1.item.1.part1')}</strong>.{' '}
                      {t('public.privacy.rights.p1.item.1.part2')}
                    </li>
                    <ul>
                      <li>{t('public.privacy.rights.p1.item.2')}</li>
                      <li>{t('public.privacy.rights.p1.item.3')}</li>
                      <li>{t('public.privacy.rights.p1.item.4')}</li>
                      <li>{t('public.privacy.rights.p1.item.5')}</li>
                      <li>{t('public.privacy.rights.p1.item.6')}</li>
                      <li>{t('public.privacy.rights.p1.item.7')}</li>
                      <li>{t('public.privacy.rights.p1.item.8')}</li>
                      <li>{t('public.privacy.rights.p1.item.9')}</li>
                    </ul>
                  </ul>
                </Typography>
                <Typography paragraph>{t('public.privacy.rights.p2')}</Typography>
                <Typography>
                  <ul>
                    <li>
                      <strong>{t('public.privacy.rights.p2.item.1.part.1')}</strong>.{' '}
                      {t('public.privacy.rights.p2.item.1.part.2')}
                    </li>
                    <li>
                      <strong>{t('public.privacy.rights.p2.item.2.part.1')}</strong>.{' '}
                      {t('public.privacy.rights.p2.item.2.part.2')}
                    </li>
                    <li>
                      <strong>{t('public.privacy.rights.p2.item.3.part.1')}</strong>.{' '}
                      {t('public.privacy.rights.p2.item.3.part.2')}
                    </li>
                  </ul>
                </Typography>
                <Typography paragraph>{t('public.privacy.rights.p3')}</Typography>
                <Typography paragraph>
                  <ul>
                    <li>{t('public.privacy.rights.p3.item.1')}</li>
                    <li>{t('public.privacy.rights.p3.item.2')}</li>
                    <li>{t('public.privacy.rights.p3.item.3')}</li>
                  </ul>
                </Typography>
                <Typography paragraph>{t('public.privacy.rights.p4')}</Typography>
                <Typography paragraph>
                  <ul>
                    <li>
                      <strong>{t('public.privacy.rights.p4.item.1.part.1')}</strong>.{' '}
                      {t('public.privacy.rights.p4.item.1.part.2')}
                    </li>
                  </ul>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.verification.process')}
                </Typography>
                <Typography paragraph>{t('public.privacy.verification.process.p1')}</Typography>
                <Typography paragraph>
                  <ul>
                    <li>{t('public.privacy.verification.process.p1.item.1')}</li>
                    <li>{t('public.privacy.verification.process.p1.item.2')}</li>
                  </ul>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.nondiscrimination')}
                </Typography>
                <Typography paragraph>{t('public.privacy.nondiscrimination.p1')}</Typography>
                <Typography paragraph>
                  <ul>
                    <li>{t('public.privacy.nondiscrimination.p1.item.1')}</li>
                    <li>{t('public.privacy.nondiscrimination.p1.item.2')}</li>
                    <li>{t('public.privacy.nondiscrimination.p1.item.3')}</li>
                    <li>{t('public.privacy.nondiscrimination.p1.item.4')}</li>
                  </ul>
                </Typography>
                <Typography paragraph>{t('public.privacy.nondiscrimination.p2')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.requests')}
                </Typography>
                <Typography paragraph>{t('public.privacy.requests.p1')}</Typography>
                <Typography paragraph>{t('public.privacy.requests.p2')}</Typography>
                <Typography paragraph>{t('public.privacy.requests.p3')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.agent.authorization')}
                </Typography>
                <Typography paragraph>{t('public.privacy.agent.authorization.p1')}</Typography>
                <Typography paragraph>
                  <ul>
                    <li>{t('public.privacy.agent.authorization.p1.item.1')}</li>
                    <li>{t('public.privacy.agent.authorization.p1.item.2')}</li>
                    <li>{t('public.privacy.agent.authorization.p1.item.3')}</li>
                  </ul>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.data.sharing')}
                </Typography>
                <Typography paragraph>{t('public.privacy.data.sharing.p1')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.not.track')}
                </Typography>
                <Typography paragraph>{t('public.privacy.not.track.p1')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.data.retention')}
                </Typography>
                <Typography paragraph>{t('public.privacy.data.retention.p1')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.updates')}
                </Typography>
                <Typography paragraph>{t('public.privacy.updates.p1')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Paper className={classes.paperNorrmal}>
                <Typography variant="h5" gutterBottom>
                  {t('public.privacy.how.contact')}
                </Typography>
                <Typography paragraph>{t('public.privacy.how.contact.p1')}</Typography>
                <Typography paragraph>{t('public.privacy.how.contact.p2')}</Typography>
                <Typography paragraph>Bringer Parcel Xpress</Typography>
                <Typography paragraph>8351 NW 21st Street,</Typography>
                <Typography paragraph>Doral, FL, 33122</Typography>
                <Typography paragraph>{t('public.privacy.how.contact.p6')}</Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </>
    );
  },
  () => true
);

export default Home;
